import React, { useState, useRef, useEffect } from "react";
import { LOCALES, useT } from "@/i18n";
import { Globe } from "lucide-react";
import { sfx } from "@/lib/sfx";

export default function LanguageSwitcher({ className = "" }) {
  const { locale, setLocale, t } = useT();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const current = LOCALES.find((l) => l.code === locale) || LOCALES[0];

  return (
    <div ref={ref} className={`relative ${className}`}>
      <button
        data-testid="language-switcher-button"
        onClick={() => { sfx.click(); setOpen((v) => !v); }}
        className="flex items-center gap-2 px-3 py-1.5 border border-white/20 hover:border-cyan-300 hover:text-cyan-300 transition-colors text-[10px] tracking-[0.3em] text-white/70"
      >
        <Globe size={12} /> {current.label} · {current.name}
      </button>
      {open && (
        <div
          data-testid="language-menu"
          className="absolute right-0 mt-2 min-w-[180px] bg-black/85 backdrop-blur-xl border border-white/10 z-30"
        >
          <div className="px-3 pt-3 pb-1 text-[9px] tracking-[0.4em] text-white/40">
            {t("common.language")}
          </div>
          {LOCALES.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}`}
              onClick={() => { sfx.click(); setLocale(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-3 py-2 text-xs tracking-widest transition-colors border-b border-white/5 last:border-0 ${
                l.code === locale
                  ? "text-cyan-300 bg-cyan-300/5"
                  : "text-white/80 hover:text-white hover:bg-white/5"
              }`}
              dir={l.dir}
            >
              <span>{l.name}</span>
              <span className="text-[10px] opacity-60">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
